import type { MonospaceCollectionMeta } from '#layers/data-model/types/schema/workspace-schema';

export function isCollectionHidden(collection: { meta?: Pick<MonospaceCollectionMeta, 'isHidden'> | null } | null | undefined): boolean {
	return collection?.meta?.isHidden === true;
}
